import { Trans } from 'react-i18next';
import { FeatureList } from './components';

export function ScalePlanDetails(): JSX.Element {
  return (
    <FeatureList
      heading={
        <Trans i18nKey="activation:dashboard.post-install-card.scale-plan-details-title">
          Welcome to <b>Hotjar Scale</b> — the highest fidelity product experience insights and
          access to all new and upcoming advanced features.
        </Trans>
      }
    >
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.all-recording-filters">
        <b>See where users get frustrated.</b> Try out all the Recordings filters, like Rage Clicks.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.user-attributes">
        <b>Advanced segmentation.</b> Your own User IDs, cohorts, and other User Attributes.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.continuous-heatmaps-recordings">
        <b>Continuously building insights.</b> Your user sessions automatically turned into Heatmaps
        & Recordings.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.saml-sso">
        <b>Bring your whole team onboard.</b> Centralized, secure authentication with SAML SSO.
      </Trans>
      <Trans i18nKey="activation:dashboard.post-install-card.plan-features.tailored-support">
        <b>Tailored support.</b> Personalized onboarding with Hotjar specialists.
      </Trans>
    </FeatureList>
  );
}
